import { Component, Input } from '@angular/core';
import { WalletTransactionKind } from '../../models/transaction.model';

const KIND_LABELS: Record<WalletTransactionKind, string> = {
  topup: 'Top-up',
  grant: 'Grant',
  adjustment: 'Adjustment',
  refund: 'Refund',
};

/**
 * One ledger entry as this table renders it. WalletTransaction already has
 * this shape, so the billing pages pass their models straight in; Home maps
 * its own OverviewActivityItem onto it (see RecentActivityCard.rows).
 */
export interface LedgerRow {
  id: string;
  createdAt: string;
  kind: WalletTransactionKind;
  description: string | null;
  amountCents: number;
  currency: string;
  isCredit: boolean;
  /** Only Home has a real per-entry status; shown when `showStatus` is on. */
  status?: string | null;
}

/**
 * The wallet ledger table, shared by Billing Overview, Billing Transactions and
 * the Home "Recent activity" card so all three read identically: date with
 * time, type, description, and a right-aligned signed amount - credits green,
 * debits in the normal text colour (red is reserved for an overdrawn balance).
 */
@Component({
  selector: 'app-txn-table',
  standalone: false,
  templateUrl: './txn-table.html',
})
export class TxnTable {
  @Input({ required: true }) rows: LedgerRow[] = [];
  /** Home shows the entry's status; the billing pages don't have one per entry. */
  @Input() showStatus = false;

  kindLabel(kind: WalletTransactionKind): string {
    return KIND_LABELS[kind] ?? kind;
  }
}
